
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from '@aws-amplify/auth';

@Component({
  components: {},
})
export default class ShowSignInCustom extends Vue {
  @Prop(Object)
  signUpConfig!: any;

  @Prop(String)
  usernameAttributes!: string;

  @Prop(Object)
  confirmSignUpConfig!: any;

  loading = false;

  placeholders = {
    username: 'amplify.Enter your Email address',
    password: 'amplify.Enter your password',
  };

  error = '';

  value = {
    username: '',
    password: '',
  };

  get LoginFields(): any[] {
    return this.signUpConfig.signUpFields.filter(
      (item: any) => item.key !== 'locale',
    );
  }

  mounted() {
    if (this.confirmSignUpConfig.username) {
      this.value.username = this.confirmSignUpConfig.username;
    }
  }

  signIn() {
    this.loading = true;
    this.removeError();
    Auth.signIn(this.value.username, this.value.password)
      .then((data) => {
        if (
          data.challengeName === 'SMS_MFA' ||
          data.challengeName === 'SOFTWARE_TOKEN_MFA'
        ) {
          AmplifyEventBus.$emit('localUser', data);
          return AmplifyEventBus.$emit('authState', 'confirmSignIn');
        }
        if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
          AmplifyEventBus.$emit('localUser', data);
          return AmplifyEventBus.$emit('authState', 'requireNewPassword');
        }
        if (data.challengeName === 'MFA_SETUP') {
          AmplifyEventBus.$emit('localUser', data);
          return AmplifyEventBus.$emit('authState', 'setMfa');
        }
        if (
          data.challengeName === 'CUSTOM_CHALLENGE' &&
          data.challengeParam &&
          data.challengeParam.trigger === 'true'
        ) {
          AmplifyEventBus.$emit('localUser', data);
          return AmplifyEventBus.$emit('authState', 'customConfirmSignIn');
        }
        return AmplifyEventBus.$emit('authState', 'signedIn');
      })
      .catch((e) => {
        if (e.code && e.code === 'UserNotConfirmedException') {
          AmplifyEventBus.$emit('localUser', { username: this.value.username });
          AmplifyEventBus.$emit('authState', 'confirmSignUp');
        } else {
          this.setError(e);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  setError(e: ErrorEvent | null): void {
    // @ts-ignore: translation module is actually loaded but ts can't seem to find it.
    this.error = e ? this.$Amplify.I18n.get(e.message || e) : null;
  }

  removeError() {
    this.setError(null);
  }

  forgot() {
    AmplifyEventBus.$emit('authState', 'forgotPassword');
  }

  signUp() {
    AmplifyEventBus.$emit('authState', 'signUp');
  }

  @Watch('$route', { immediate: true })
  onUrlChange(route: any) {
    if (route.name === 'passwordreset') {
      AmplifyEventBus.$emit('authState', 'passwordResetByConsole');
    }
  }
}
